<template>
<div id="emisores" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Mercancía/Producto" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                       <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" title="Exportar" :data="datafiltered" :exportFields="mercancias.camposexcel" name="Mercancias.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="mercancias.camposLayout" :exportFields="mercancias.encabezadoLayout" name="Layout Mercancias.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{
                            update ? "Actualizar" : "Nuevo"
                          }}
                                                Mercancía/Producto</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field label="Clave" type="text" @input="model.clave = model.clave.toUpperCase()" v-model="model.clave" :rules="[rules.required, verificaClave]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field label="Descripción 1" type="text" v-model="model.descripcion1" :rules="[rules.required]" maxlength="150" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-text-field label="Descripción 2" type="text" v-model="model.descripcion2" maxlength="150" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Fracción Arancelaria 1" type="text" v-model="model.fraccion1" :rules="[rules.required, rules.entero]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Identificador Específico 1" type="text" v-model="model.identificador1" :rules="[rules.required]" maxlength="4" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-autocomplete v-model="model.umt1" :items="unidades" :hide-no-data="true" :hide-selected="true" :item-text="claveNombre" item-value="clave" label="Selecciona UMT" :rules="[rules.required]" >
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Fracción Arancelaria 2" type="text" v-model="model.fraccion2" :rules="[rules.enteroNull]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Identificador Específico 2" type="text" v-model="model.identificador2" maxlength="4" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-autocomplete v-model="model.umt2" :items="unidades" :hide-no-data="true" :hide-selected="true" :item-text="claveNombre" item-value="clave" label="Selecciona UMT" >
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>

                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="mercancias.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_mercancia)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_mercancia)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        columns: ["clave", "descripcion1", "fraccion1", "identificador1", "umtNombre", "actions"],
        show_loading: true,
        options: {
            filterable: ["clave", "descripcion1", "fraccion1", "identificador1", "umtNombre"],
            sortable: ["clave", "descripcion1", "fraccion1", "identificador1", "umtNombre"],

            headings: {
                clave: "Clave",
                descripcion1: "Descripción",
                fraccion1: "Fracción",
                identificador1: "Identificador Específico",
                umtNombre: "UMT",
                actions: "Operaciones"
            },
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Mercancía/Producto",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "clave"
        },
        search: "",
        model: {
            id_mercancia: 0,
            clave: "",
            descripcion1: "",
            descripcion2: "",
            fraccion1: "",
            identificador1: "",
            umt1: "",
            fraccion2: "",
            identificador2: "",
            umt2: "",
            cliente: "",
            user_updated: "",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            entero: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Número entero";
            },
            enteroNull: value => {
                const pattern = /^[\d]*$/;
                if (value != undefined && value.toString().trim().length != 0)
                    return pattern.test(value) || "Número entero";
                else
                    return true;
            }
        },
        clave_update: "",
        unidades: [],
        mercancias: {
            selected: [],
            camposexcel: {
                Clave: "clave",
                "Descripción 1": "descripcion1",
                "Descripción 2": "descripcion2",
                "Fracción 1": "fraccion1",
                "Identificador 1": "identificador1",
                "UMT 1": "umt1",
                "Fracción 2": "fraccion2",
                "Identificador 2": "identificador2",
                "UMT 2": "umt2",
            },
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                clave: "clave",
                descripcion1: "descripcion1",
                descripcion2: "descripcion2",
                fraccion1: "fraccion1",
                identificador1: "identificador1",
                umt1: "umt1",
                fraccion2: "fraccion2",
                identificador2: "identificador2",
                umt2: "umt2",
            },
            camposLayout: [{
                clave: "[Clave de mercancía/producto]",
                descripcion1: "",
                descripcion2: "",
                fraccion1: "[Máximo 10 dígitos]",
                identificador1: "[Máximo 4 caracteres]",
                umt1: "[Clave de la Unidad de Medida]",
                fraccion2: "[Máximo 10 dígitos]",
                identificador2: "[Máximo 4 caracteres]",
                umt2: "[Clave de la Unidad de Medida]",
            }]
        },
        camposObligatorios: [
            "clave",
            "descripcion1",
            "fraccion1",
            "identificador1",
            "umt1",
        ],

        json_meta: [{
            'key': 'charset',
            'value': 'utf-8'
        }],

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.mercancias.items;
            }

        },
    },
    methods: {
        claveNombre: function (row) {
            return row.clave + " - " + row.descripcion;
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Mercancía/Producto";
                this.update = false;
            } else {
                this.title = "Actualizar Mercancía/Producto";
                this.update = true;
                this.clave_update = this.model.clave;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
            this.model.user_updated = this.$local_storage.get("email");
        },

        verificaClave: function (value) {
            var claves = this.mercancias.items.map(function (item) {
                return item.clave
            });
            var finder = claves.indexOf(value);

            if (finder != -1 && ((this.update == false) || (this.update == true && this.clave_update != value)))
                return "La clave ya existe";
            else
                return true;
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;

                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_mercancia + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    }).then(() => {
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },
        obtenerNombreUnidad: function (unidad) {
            if (this.unidades.length > 0) {
                var search = this.unidades.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == unidad.toString().trim().toLowerCase();
                });
                return search.length > 0 ? (search[0].clave + " (" + search[0].descripcion + ")") : "No encontrado";
            }
        },

        cargar: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_mercancias/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.mercancias.items = res.data;
                        for (var k in this.mercancias.items) {
                            this.mercancias.items[k].umtNombre = this.obtenerNombreUnidad(this.mercancias.items[k].umt1);
                        }
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        }, //delete
        cargarUnidadesMedida: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente"),
            };
            axios
                .post(this.$hostname + "catalogos/unidades_medida/lista/", datos)
                .then(response => {
                    this.unidades = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las unidades de medida.",
                        footer: ""
                    });
                });
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaClaveMercancia: function (clave) {
            if (this.mercancias.items.length > 0) {
                var search = this.mercancias.items.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave.toString().trim().toLowerCase();
                });
                if (search.length > 0)
                    return true;
                else
                    return false;
            }
        },
        verificaUnidadMedida: function (unidad) {
            if (this.unidades.length > 0) {
                var search = this.unidades.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == unidad.toString().trim().toLowerCase();
                });
                return search.length > 0;
            }
        },
        verificaFraccion: function (fraccion) {
            const pattern = /^[\d]*$/;
            return pattern.test(fraccion);
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");
                    results[k]["cliente"] = thisObject.$local_storage.get("id_cliente");

                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                        if (results[k]["clave"] == undefined) {
                            errores++;
                            erroresText += "- La clave no debe ir vacía.<br/>";
                        } else if (results[k]["clave"] != undefined && thisObject.verificaClaveMercancia(results[k]["clave"])) {
                            errores++;
                            erroresText += "- La clave " + results[k]["clave"] + " ya existe.<br/>";
                        } else {
                            results[k]["clave"] = results[k]["clave"].toString().toUpperCase();
                        }

                        if (!thisObject.verificaFraccion(results[k]["fraccion1"])) {
                            errores++;
                            erroresText += "- La fracción " + results[k]["fraccion1"] + " debe ser número entero.<br/>";
                        }
                        if (results[k]["fraccion2"] != undefined && !thisObject.verificaFraccion(results[k]["fraccion2"])) {
                            errores++;
                            erroresText += "- La fracción " + results[k]["fraccion2"] + " debe ser número entero.<br/>";
                        }

                        if (!thisObject.verificaUnidadMedida(results[k]["umt1"])) {
                            errores++;
                            erroresText += "- La clave de unidad " + results[k]["umt1"] + " no existe.<br/>";
                        }
                        if (results[k]["umt2"] != undefined && !thisObject.verificaUnidadMedida(results[k]["umt2"])) {
                            errores++;
                            erroresText += "- La clave de unidad " + results[k]["umt2"] + " no existe.<br/>";
                        }
                    }
                    //console.log("Key is " + k + ", value is" + results[k]);
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {

                        this.importData.push({
                            clave: results[k]["clave"],
                            descripcion1: results[k]["descripcion1"],
                            descripcion2: results[k]["descripcion2"],
                            fraccion1: results[k]["fraccion1"],
                            identificador1: results[k]["identificador1"],
                            umt1: results[k]["umt1"],
                            fraccion2: results[k]["fraccion2"],
                            identificador2: results[k]["identificador2"],
                            umt2: results[k]["umt2"],
                            cliente: results[k]["cliente"],
                            user_updated: results[k]["user_updated"],
                        });

                    }

                    axios
                        .post(this.URL + "importar_mercancias/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }

                                            });
                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/mercancias/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.cargarUnidadesMedida();
    }
};
</script>
